import React, { Component } from 'react';



import firebase from './firebase.js';




import './App.css';
import TrainControl from './TrainControl';


import initReactFastclick from 'react-fastclick';
initReactFastclick();

class App extends Component {
	componentDidMount() {
		this.firebaseRef = firebase.database().ref('/train');
	    this.firebaseCallback = this.firebaseRef.on('value', (snap) => {      
	    	this.setState({ someData: snap.val() });
	    });
    }
    
    componentWillUnmount() {
		// Un-register the listener on '/someData'.
		this.firebaseRef.off('value', this.firebaseCallback);
	}
	
	
  render() {
    return (
      <div className="App">
        <TrainControl />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js